export const DEFAULT_COUPON_CONTENT = {
  page_title: "Buy & Win Raffle Coupon",
  logo_image: "/old_logo.png",
  logo_alt: "Everyday Discount Center",
  raffle_background_image: "/images/buy-win-raffle.png",
  promo_text: "Get a free raffle coupon with every product you purchase!",
  brand_title: "EVERYDAY",
  brand_subtitle: "DISCOUNT CENTER",
  terms_title: "Terms & Conditions",
  terms_items: [
    "Coupon for every purchase above 10 BHD",
    "Bring original invoice and raffle coupon",
  ],
  show_promotion_dates: "Y",
  promotion_label: "Promotion",
  contact_mobile: "+973 336 911 25",
  contact_location: "Shop No. 48 B, Road 359, Block 321, Manama",
  side_note: "* Terms and conditions apply",
};

export const mergeCouponContent = (content = {}) => ({
  ...DEFAULT_COUPON_CONTENT,
  ...content,
  terms_items: content.terms_items?.length
    ? content.terms_items
    : DEFAULT_COUPON_CONTENT.terms_items,
});
